export const roles = {
  Platform: [
    'hotProspect',
    'bankDecline',
    'brokerReferral',
    'toBeCalled',
    'eliteReferral',
    'referral',
    'notReferral',
    'trustPilot',
    'trustpilotInvitationSent',
    'financialsSent',
    'autoSendEnquiries',
    'softSearchConsent',
    'questionsIncomplete',
    'questionsComplete',
    'open',
    'closed',
    'noEnquiries',
    'hasEnquiryErrors',
    'hasDocuments',
    'newsletterSignup'
  ],

  'Call Centre': [
    'bankDecline',
    'brokerReferral',
    'toBeCalled',
    'referral',
    'questionsIncomplete',
    'questionsComplete',
    'closed',
    'noEnquiries',
    'hasDocuments'
  ],

  Broker: ['toBeCalled', 'closed', 'open', 'noEnquiries', 'hasDocuments', 'softSearchConsent'],

  'Property Broker': ['toBeCalled', 'closed', 'open', 'noEnquiries', 'hasDocuments', 'softSearchConsent']
};
